export default {
  sendEmail: 'Send e-mail',
  export: 'Export',
  confirm: 'Confirm',
  cancel: 'Cancel',
  close: 'Close',
  search: 'Search',
  actions: 'Actions',
  noData: 'No data available',
  noResults: 'No results found',
  loading: 'Loading...',
};
